import React, { useState, useEffect } from "react";
import axios from "axios";
import { InstanceTooltip } from "../../component/ecovestwelcome/InstanceTooltip";
import { NotifBreathing } from "../../component/ecovestwelcome/NotifBreathing";
import { PlantingTree } from "../../component/ecovestwelcome/PlantingTree";
import { Tree } from "../../component/ecovestwelcome/Tree";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import WelcomeTour from "../../component/welcometour";
import "./style.css";

const SherwoodForest = () => {
  const user = useSelector(state => state.auth.user);
  const { id } = user.claims;
  const investorId = id && id.toString();
  const navigate = useNavigate();
  const [xp, setXp] = useState(0);
  const [allTrees, setAllTrees] = useState([]);
  const [forests, setForests] = useState([]);
  const [isPlanting, setIsPlanting] = useState(false);
  const [plantingError, setPlantingError] = useState(null);
  const [showPlantPopup, setShowPlantPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showXpInfoPopup, setShowXpInfoPopup] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showTour, setShowTour] = useState(false);

  const fetchData = async () => {
    try {
      // Fetch XP data
      const xpResponse = await axios.get(`${apiUrl}/ecovest/myxp/${investorId}`);
      if (xpResponse.data.status.code === 1) {
        setXp(xpResponse.data.data[0].xp);
      }

      // Fetch ALL trees data
      const treesResponse = await axios.get(`${apiUrl}/ecovest/trees/3`); // 3 is Sherwood forest
      if (treesResponse.data.status.code === 1) {
        const treesData = treesResponse.data.data.flat();
        setAllTrees(treesData);
      }
      
      // Fetch forests data
      const forestsResponse = await axios.get(`${apiUrl}/ecovest/forest`);
      if (forestsResponse.data.status.code === 1) {
        const forestsData = forestsResponse.data.data.flat();
        setForests(forestsData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [apiUrl, investorId]);

  const handlePlantTree = async () => {
  // Check if user has 0 XP
  if (xp === 0) {
    setShowXpInfoPopup(true);
    return;
  }

  setIsPlanting(true);
  setPlantingError(null);
  
  try {
    const response = await axios.post(`${apiUrl}/ecovest/Create`, {
      idForest: 3, // Sherwood forest
      investorId: investorId
    }, {
      headers: {
        'accept': 'text/plain',
        'Content-Type': 'application/json'
      }
    });

    if (response.data.status.code === 1) {
      // Refresh data after successful planting
      await fetchData();
      setShowPlantPopup(false);
      setShowSuccessPopup(true);
    } else {
      setPlantingError(response.data.status.message);
    }
  } catch (error) {
    setPlantingError(error.message);
    console.error("Error planting tree:", error);
  } finally {
    setIsPlanting(false);
  }
};


  const getTreeClass = (tree, index) => {
    return tree?.className ? `tree-${tree.className}` : 
           index === 0 ? "tree-instance" :
           index === 1 ? "design-component-instance-node" :
           `tree-${index + 1}`;
  };

  const formatXP = (xp) => {
    if (xp >= 1000) {
      return `${(xp / 1000).toFixed(xp % 1000 === 0 ? 0 : 1)}K XP`;
    }
    return `${xp} XP`;
  };

  const formatTree = (xp) => {
    if (xp >= 1000) {
      return `${(xp / 1000).toFixed(xp % 1000 === 0 ? 0 : 1)}`;
    }
    return `(${xp})`;
  };

  const getTreeCountForForest = (forestId) => {
    if (forestId === 2) {
      return allTrees.length;
    }
    return 0;
  };

  const getTreesPlantedText = (forest) => {
    if (forest.capacity === 0) {
      return "coming soon";
    }
    const plantedCount = getTreeCountForForest(forest.id);
    return `${plantedCount}/${forest.capacity} trees planted`;
  };
  const plantedTreesByForest = getTreeCountForForest(2); // Assuming 2 is the Nottingham forest ID
  const getCityNameClass = (index) => {
    return index === 2 ? "city-name-2" : 
           index === 4 ? "city-name-3" : 
           "city-name";
  };
  return (
    <div className="welcome-screen mx-auto">
      <div>
        <div className="map-container">
          <div className="overlap-group">
            <div className="map-sizes">
              <img className="snazzy-image-sherwood" alt="Snazzy image"/>
            </div>
            <div className="btn-group new-dropdown-btn d-lg-none d-md-flex d-flex">
              <button 
                className="btn-bars ndb2 dropdown-toggle" 
                type="button" 
                id="dropdownMenuButton" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
              >
                <i className="fa fa-bars icon-bars" aria-hidden="true"></i>
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <Link className="dropdown-item" to="/Ecovest/EarnXp">Earn XP</Link>
                </li>
                <li>
                  <button 
                    className="dropdown-item" 
                    onClick={() => setShowTour(true)}
                  >
                    Tour
                  </button>
                </li>
                <li>
                  <a className="dropdown-item" href="/Ecovest/Leaderboard">Leaderboard</a>
                </li>
              </ul>
            </div>
            <div className="trees-sherwood">
              {allTrees.map((tree, index) => (
                <Tree 
                  key={tree.id} // Using tree.id as key instead of index
                  className={`tree-sherwood ${getTreeClass(tree, index)}`} 
                  property1="default" 
                />
              ))}
            </div>
            <div className="current-XP">
              <img
                className="green-coin"
                alt="Green coin"
                src="/assets/images/ecovestwelcomeimg/green-coin.svg"
              />
              <div className="text-wrapper-6">{formatXP(xp)}</div>
            </div>
            <a className="earn-XP" href="/Ecovest/EarnXp">
              <i className="fa fa-star-o icons-font-awesome-2 text-black" aria-hidden="true"></i>
              <div className="text-wrapper-6">Earn XP</div>

              <NotifBreathing
                breathing="out"
                className="notif-breathing-animation"
              />
            </a>
            <a className="leaderboard" href="/Ecovest/Leaderboard">
              <i className="fa-solid fa-ranking-star icons-font-awesome-2"></i>
              <div className="text-wrapper-7">Leaderboard</div>
            </a>

            <button 
              className="tour-again" 
              onClick={() => setShowTour(true)}
            >
              <i className="fa-solid fa-question icons-font-awesome-3 me-2"></i>
              <div className="div">Tour</div>
            </button>
            <div className="d-lg-flex d-none">
              <p className="p">346,648 Planted trees (all forests)</p>
              <div className="text-wrapper-5">248,004 people participated</div>
            </div>
            <div className="frame d-lg-flex d-md-none d-none">
              <div className="table-row">
                <div className="frame-2" />

                <div className="frame-3">
                  <div className="user">
                    <div className="text-wrapper-2">Guy Hawkins</div>

                    <div className="div-wrapper">
                      <div className="text-wrapper-3">8K XP</div>
                    </div>
                  </div>

                  <div className="text-wrapper-4">#Save the earth</div>
                </div>
              </div>

              <div className="table-row">
                <div className="frame-4" />

                <div className="frame-3">
                  <div className="user">
                    <div className="text-wrapper-2">Guy Hawkins</div>

                    <div className="div-wrapper">
                      <div className="text-wrapper-3">9K XP</div>
                    </div>
                  </div>

                  <div className="text-wrapper-4">#Save the earth</div>
                </div>
              </div>

              <div className="table-row">
                <div className="frame-5" />

                <div className="frame-3">
                  <div className="user">
                    <div className="text-wrapper-2">Guy Hawkins</div>

                    <div className="div-wrapper">
                      <div className="text-wrapper-3">14K XP</div>
                    </div>
                  </div>

                  <div className="text-wrapper-4">#Save the earth</div>
                </div>
              </div>

              <div className="table-row">
                <div className="frame-6" />

                <div className="frame-3">
                  <div className="user">
                    <div className="text-wrapper-2">Guy Hawkins</div>

                    <div className="div-wrapper">
                      <div className="text-wrapper-3">14K XP</div>
                    </div>
                  </div>

                  <div className="text-wrapper-4">#Save the earth</div>
                </div>
              </div>

              <div className="table-row">
                <div className="frame-7" />

                <div className="frame-3">
                  <div className="user">
                    <div className="text-wrapper-2">Guy Hawkins</div>

                    <div className="div-wrapper">
                      <div className="text-wrapper-3">14K XP</div>
                    </div>
                  </div>

                  <div className="text-wrapper-4">#Save the earth</div>
                </div>
              </div>

              <div className="table-row">
                <div className="frame-8" />

                <div className="frame-3">
                  <div className="user">
                    <div className="text-wrapper-2">Guy Hawkins</div>

                    <div className="div-wrapper">
                      <div className="text-wrapper-3">164 trees</div>
                    </div>
                  </div>

                  <div className="text-wrapper-4">#Save the earth</div>
                </div>
              </div>
            </div>
          </div>
          <button className="go-back-button d-flex gap-2 p-2" onClick={() => navigate("/Ecovest/Onboarding")}>
            <i class="fa fa-arrow-left icons-font-awesome-4 text-black align-self-center" aria-hidden="true"></i>
            <img className="logo d-lg-flex d-md-flex d-none" alt="Logo" src="/assets/images/ecovestwelcomeimg/logo.svg" />
            <img className="logo d-lg-none d-md-none d-flex" alt="Logo" src="/assets/images/ecovestwelcomeimg/LogoEcovestmobile.png" />
            <div className="text">{""}</div>
          </button>
          <div className="d-lg-none d-md-none d-flex w-100 justify-content-center">
            <button className="button-bottom" onClick={() => setShowPlantPopup(true)} disabled={isPlanting} >
              <div className="text-wrapper-8">
                {isPlanting ? 'Planting...' : 'Plant a tree'}
              </div>
              <InstanceTooltip
                className="instance-tooltip-instance"
                override={
                  <PlantingTree
                    className="planting-tree-available-trees"
                    image="/assets/images/ecovestwelcomeimg/image-86-1.png"
                    myTrees={formatTree(xp)}
                  />
                }
                stateProp="default"
                toolTipDirectionTopClassName="instance-tooltip-3"
                toolTipIndicatorClassName="instance-tooltip-2"
                toolTipTooltipContent="3 eco-friendly saplings are available for planting."
                tooltipPosition="bottom"
              />
            </button>
            
            {plantingError && (
              <div className="text-danger mt-2">{plantingError}</div>
            )}
          </div>
          {showPlantPopup && (
            <div className="plant-popup-overlay">
              <div className="plant-popup">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h1 className="text-wrapper-h1 mb-0">Planting a tree</h1>
                  <button 
                    className="btn-close" 
                    onClick={() => setShowPlantPopup(false)}
                    aria-label="Close"
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
                
                <div className="form-check form-switch mb-2">
                  <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                  <label className="form-check-label d-flex" htmlFor="flexSwitchCheckDefault">Hide my name</label>
                </div>      
                <div>
                  <div className="d-flex">
                    <p>What do you want to say</p>
                  </div>

                  <div className="d-flex flex-lg-row flex-md-row flex-sm-column flex-column gap-2 input-plant p-3">
                    <div className="rechercher">Green today, greener tomorrow.</div>
                    <div>
                      <button className="btn btn-primary">
                        <i className="fa fa-refresh" aria-hidden="true"></i>
                        Randomize
                      </button>
                    </div>
                  </div>
                  <button className="plant-button mt-4 w-100 py-3" onClick={handlePlantTree} disabled={isPlanting}>
                    Plant now
                  </button>
                </div>
              </div>
            </div>
          )}
          {showXpInfoPopup && (
            <div className="plant-popup-overlay">
              <div className="plant-popup">
                <div className="d-flex justify-content-end">
                  <button 
                    className="btn-close" 
                    onClick={() => setShowXpInfoPopup(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <h1 className="text-wrapper-h1 mb-3">🌱 How to Earn XP</h1>
                <div className="xp-info-content">
                  <p>You need XP to plant trees. Here's how you can earn XP:</p>
                  <ul>
                    <li>✅ Complete daily challenges</li>
                    <li>👥 Invite friends to join</li>
                    <li>🎉 Participate in community events</li>
                    <li>🌍 Engage with eco-friendly activities</li>
                  </ul>
                  <p>🌳 <b>Start earning XP today to plant your first tree!</b></p>
                </div>
                <div className="d-flex justify-content-between mt-4">
                  <button 
                    className="btn btn-outline-secondary" 
                    onClick={() => setShowXpInfoPopup(false)}
                  >
                    Close
                  </button>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => {
                      setShowXpInfoPopup(false);
                      navigate("/Ecovest/EarnXp");
                    }}
                  >
                    Earn XP Now
                  </button>
                </div>
              </div>
            </div>
          )}
          {showSuccessPopup && (
            <div className="success-popup-overlay">
              <div className="success-popup d-flex flex-column align-items-center position-relative">
                {/* Close button (X) in top-right corner */}
                <button 
                  className="btn-close position-absolute top-0 end-0 m-3" 
                  onClick={() => setShowSuccessPopup(false)}
                  aria-label="Close"
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>

                <h1 className="mb-3">You&#39;ve Leafed a Mark!</h1>
                <h4>You&#39;ve just made the world a greener place!</h4>
                <p>Share your accomplishment with your friends and family on social
                media. <br/>Let them know how easy it is to make a difference with TANNIT.</p>
                <div className="d-lg-flex d-md-flex d-none justify-content-center mb-2 success-popup-image">
                  <img className="d-flex w-50 mb-2" alt="Logo mark" src="/assets/images/ecovestonboarding/LogoEcovest.png" />
                  <h1 className="color-h1 mt-2">{plantedTreesByForest}</h1>
                  <h3>PLANTED TREES</h3>
                  <h3>UNTIL NOW</h3>
                </div>
                <div className="d-flex flex-column align-items-center">
                  <p>Share The moment</p>
                </div>

                {/* Social Sharing Buttons - Updated for mobile apps */}
                <div className="social-share-buttons d-flex flex-wrap justify-content-center gap-2 mb-4">
                  {/* LinkedIn */}
                  <a 
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
                    onClick={(e) => {
                      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        e.preventDefault();
                        window.open(`linkedin://shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}&title=I just planted a tree with TANNIT!`);
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fab fa-linkedin"></i> LinkedIn
                  </a>
                  
                  {/* Facebook */}
                  <a 
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                    onClick={(e) => {
                      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        e.preventDefault();
                        window.open(`fb://sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`);
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fab fa-facebook"></i> Facebook
                  </a>
                  
                  {/* Twitter/X */}
                  <a 
                    href={`https://twitter.com/intent/tweet?text=I just planted a tree with @TANNIT! Join me in making the world greener. Together we've planted 3791 trees so far!&url=${encodeURIComponent(window.location.href)}`}
                    onClick={(e) => {
                      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        e.preventDefault();
                        window.open(`twitter://post?message=I just planted a tree with @TANNIT! ${encodeURIComponent(window.location.href)}`);
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fab fa-twitter"></i> Twitter/X
                  </a>
                  
                  {/* WhatsApp */}
                  <a 
                    href={`https://api.whatsapp.com/send?text=I just planted a tree with TANNIT! ${encodeURIComponent(window.location.href)}`}
                    onClick={(e) => {
                      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        e.preventDefault();
                        window.open(`whatsapp://send?text=I just planted a tree with TANNIT! ${encodeURIComponent(window.location.href)}`);
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fab fa-whatsapp"></i> WhatsApp
                  </a>
                  
                  {/* Telegram */}
                  <a 
                    href={`tg://msg_url?url=${encodeURIComponent(window.location.href)}&text=I just planted a tree with TANNIT!`}
                    onClick={(e) => {
                      if (!/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        e.preventDefault();
                        window.open(`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=I just planted a tree with TANNIT!`);
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fab fa-telegram"></i> Telegram
                  </a>
                  
                  {/* Instagram/Threads */}
                  <button 
                    onClick={() => {
                      const text = `I just planted a tree with TANNIT! ${window.location.href}`;
                      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        window.open(`instagram://library?AssetPath=${encodeURIComponent(window.location.href)}&InstagramCaption=${encodeURIComponent(text)}`);
                      } else if (/Android/i.test(navigator.userAgent)) {
                        window.open(`intent://share?text=${encodeURIComponent(text)}#Intent;package=com.instagram.android;scheme=https;end`);
                      } else {
                        window.open(`https://www.threads.net/intent/post?text=${encodeURIComponent(text)}`);
                      }
                    }}
                    className="btn btn-outline-secondary"
                  >
                    <i className="fab fa-threads"></i> Threads
                  </button>
                  
                  {/* Discord */}
                  <button 
                    onClick={() => {
                      const text = `I just planted a tree with TANNIT! Join me in making the world greener. Together we've planted 3791 trees so far! ${window.location.href}`;
                      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        navigator.clipboard.writeText(text).then(() => {
                          window.open('discord://');
                        });
                      } else {
                        navigator.clipboard.writeText(text).then(() => {
                          alert('Copied to clipboard! You can now paste this in Discord.');
                        });
                      }
                    }}
                    className="btn btn-outline-secondary"
                  >
                    <i className="fab fa-discord"></i> Discord
                  </button>
                </div>

                <button 
                  onClick={() => setShowSuccessPopup(false)}
                  className="btn btn-primary"
                >
                  Close
                </button>
              </div>
            </div>
          )}
          <div className="w-100 justify-content-center d-lg-flex d-md-flex d-none">
            <button 
              className="button-2" 
              onClick={() => setShowPlantPopup(true)}
              disabled={isPlanting}
            >
              <div className="text-wrapper-8">
                {isPlanting ? 'Planting...' : 'Plant a tree'}
              </div>

              <InstanceTooltip
                className="instance-tooltip-instance"
                override={
                  <PlantingTree
                    className="planting-tree-available-trees"
                    image="/assets/images/ecovestwelcomeimg/image-86-1.png"
                    myTrees={formatTree(xp)}
                  />
                }
                stateProp="default"
                toolTipDirectionTopClassName="instance-tooltip-3"
                toolTipIndicatorClassName="instance-tooltip-2"
                toolTipTooltipContent="3 eco-friendly saplings are available for planting."
                tooltipPosition="bottom"
              />
            </button>
            
            {plantingError && (
              <div className="text-danger mt-2">{plantingError}</div>
            )}
          </div>
          <div className="containers ms-5 d-lg-flex d-md-flex d-none">
            {forests.map((forest, index) => (
              <div className="city-info" key={forest.id}>
                <div className={getCityNameClass(index)}>
                  <a className="forest-link" href={`/Ecovest/${forest.nameForest}`}>{forest.nameForest}</a>
                </div>
                <div className="trees-planted">
                  {getTreesPlantedText(forest)}
                </div>
              </div>
            ))}
          </div>
          <div id="forestCarousel" className="carousel slide containers d-lg-none d-md-none d-flex w-100 mt-3" data-bs-ride="carousel">
            <div className="carousel-inner">
              {forests.map((forest, index) => (
                <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={forest.id}>
                  <div className="city-info">
                    <div className={getCityNameClass(index)}>
                      {forest.nameForest}
                    </div>
                    <div className="trees-planted">
                      {getTreesPlantedText(forest)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#forestCarousel"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#forestCarousel"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
      <WelcomeTour 
        show={showTour} 
        onFinish={() => setShowTour(false)} 
      />
    </div>
  );
};
export default SherwoodForest;
